export default __webpack_public_path__ + "static/media/signup_3.c1d0d842.jpg";